import React from 'react';
import { newlinify } from '../helpers';

export default function DangerousHtml({ html, ...restProps }) {
	return <div dangerouslySetInnerHTML={{ __html: newlinify(html) }} {...restProps} />;
}
